module.exports = __webpack_public_path__ + "static/v1.a-2a8014cb9cf8f3ea989796519fe16bd3.jpg";